import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserUtils } from '@azure/msal-browser';
import { b2cPolicies } from './auth/b2c-config';

import { RedirectService } from './shared/services/redirect-service';

import { AlertComponent } from './pages/alert/alert.component';
import { HomeComponent } from './pages/home/home.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { TosComponent } from './pages/tos/tos.component';
import { ForbiddenComponent } from './pages/forbidden/forbidden.component';
import { GeneralErrorComponent } from './pages/general-error/general-error.component';
import { FailedComponent } from './pages/failed/failed.component';
import { UnifiedSignUpSignInComponent } from './azureb2c/unified-sign-up-sign-in/unified-sign-up-sign-in.component';
 
const routes: Routes = [
	{
		path: 'about-us',		
		loadChildren: () => import('./aboutus/aboutus.module').then(m => m.AboutusModule)
	},
	{	path: 'account', 
		loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
	{
		path: 'business',		
		loadChildren: () => import('./business/business.module').then(m => m.BusinessModule)
	},
	{
		path: 'cart',
		loadChildren: () => import('./cart/cart.module').then(m => m.CartModule)
	},
	{
		path: 'cruises',
		loadChildren: () => import('./cruises/cruises.module').then(m => m.CruisesModule)
	},
	{
		path: 'destinations',
		loadChildren: () => import('./destination/destination.module').then(m => m.DestinationModule)
	},
	{
		path: 'excursions',
		loadChildren: () => import('./excursion/excursion.module').then(m => m.ExcursionModule)
	},
	{
		path: 'groups',
		loadChildren: () => import('./groups/groups.module').then(m => m.GroupsModule)
	},
	{
		path: 'support',
		loadChildren: () => import('./support/support.module').then(m => m.SupportModule)
	},
	
	{ path: b2cPolicies.loginFailedPath, component: FailedComponent },
	{ path: 'not-found', component: NotFoundComponent, canActivate: [ RedirectService ] },
	{ path: 'forbidden', component: ForbiddenComponent },
	{ path: 'general-error', component: GeneralErrorComponent },
	{ path: 'alert', component: AlertComponent },
	{ path: 'privacy', component: PrivacyComponent },
	{ path: 'terms-of-service', component: TosComponent },
	{ path: '', component: HomeComponent },
	{ path: 'azureb2c', children: [
		{ path: 'login', component: UnifiedSignUpSignInComponent, data: { title : 'Sign In', azureb2c: true} },
		{ path: 'create', component: UnifiedSignUpSignInComponent, data: { title : 'Create Account', azureb2c: true } },
		{ path: 'forgot-password', component: UnifiedSignUpSignInComponent, data: { title : 'Forgot Password', azureb2c: true } }
	]},
	{ path: '**', redirectTo: '/not-found' }
	
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {
		initialNavigation: typeof window === "undefined" ||  (!BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()) ? 'enabled' : 'disabled',
		onSameUrlNavigation: 'reload'
	  })],
	exports: [RouterModule]
})
export class AppRoutingModule { }
